import antdData from 'antd/lib/locale-provider/en_US'
import localeData from 'react-intl/locale-data/en'

const messages = {
  'topBar.issuesHistory': 'Issues History',
  'topBar.projectManagement': 'Project Management',
  'topBar.typeToSearch': 'Type to search...',
  'topBar.buyNow': 'Buy Bundle $26',
  'topBar.bitcoin': 'Bitcoin',
  'topBar.profileMenu.hello': 'Hello',
  'topBar.profileMenu.billingPlan': 'Billing Plan',
  'topBar.profileMenu.role': 'Role',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Phone',
  'topBar.profileMenu.editProfile': 'Edit Profile',
  'topBar.profileMenu.logout': 'Logout',
  'topBar.profileMenu.apicredentials': 'API Credentials ',
  'topBar.profileMenu.profile': 'User Profile',
  'topBar.profileMenu.changePassword': 'Change Password',
  'topBar.profileMenu.switchAccount': 'Switch Account',
  'topBar.profileMenu.impersonateLogout': 'Logout from Impersonate',
  'topBar.profileMenu.companyProfile': 'Company Profile',

  'sec1.header1': 'DISCOVER THE TRACEABILITY ',
  'sec1.header2': 'OF YOUR TOUS JEWELRY',
  'sec1.text':
    'To speak of sustainability is to speak of traceability. At TOUS, we are pioneers in disclosing our jewelry’s complete traceability, from the mining company to the moment it arrives to you. With Tracemark, you can be sure that your gemstone is 100% ethical and sustainable, from start to finish.',

  'sec2.description': 'Description',
  'sec2.button': 'ID DIGITAL',

  'rawMaterials.header': 'Raw materials',
  'rawMaterials.header.text': 'Gold and diamonds that are responsibly sourced.',

  'rawMaterials.sec1.header1': '100% ethical and ',
  'rawMaterials.sec1.header2': 'recycled gold',
  'rawMaterials.sec1.text1':
    'This piece is made from 100% ethically, recycled and responsibly sourced gold, originating from refineries that only work with CoC (Chain of Custody) gold. RJC (Responsible Jewellery Council) Chain of Custody standards guarantee that the gold has been extracted sustainably and following the RJC Code of Practice.',
  'rawMaterials.sec1.text2':
    'The gold used in this piece of jewelry comes from sources that have been verified and that comply with the best international environmental practices and social standards recognized throughout the world.',
  'rawMaterials.sec1.notTraceableMaterial': 'Non-Tracemark material:',

  'rawMaterials.sec2.header1': 'Traceable,',
  'rawMaterials.sec2.header2': 'responsibly sourced',
  'rawMaterials.sec2.header3': 'diamonds',
  'rawMaterials.sec2.text1.1':
    'The diamonds in this piece of jewelry come from the mining company ',
  'rawMaterials.sec2.text1.2':
    ', a certified member of RJC or DeBeers Sightholder, which guarantees responsible sourcing and compliance with sustainability and ethical practices along the entire length of the supply chain.',
  'rawMaterials.sec2.text2': 'The country of origin of the diamonds is ',
  'rawMaterials.sec2.text3':
    'Every single diamond is verified with its own Kimberley Process Certificate that verifies its authenticity, provenance and ethical extraction.',
  'rawMaterials.sec2.text4.1': 'The',
  'rawMaterials.sec2.text4.2': 'Kimberley Process Certificate',
  'rawMaterials.sec2.text4.3':
    'imposes extensive requirements on its members to permit them to certify shipments of raw diamonds as “conflict free” in order to avoid conflict diamonds from entering legitimate trade.',

  'fabricationProcess.header1': 'The fabrication process: ',
  'fabricationProcess.header2': 'the art of manufacture',

  'fabricationProcess.text1':
    'The manufacture of a piece of jewelry begins with the inspiration of an emotion or idea that is then converted into a design. Expert jewelers convert this design into a unique piece of jewelry using a fabrication process that reflects the tradition of the craft while incorporating innovative production techniques. This piece is made in Cordoba in the south of Spain. From the modeling and casting to the finishing, setting and polishing, our Cordoba craftsmen give shape to this piece with the passion of their profession and their expert dedication.',
  'fabricationProcess.text2':
    'All the documentation and information about the traceability of this piece of jewelry has been verified by an external RJC-accredited auditor.',
  'fabricationProcessTousHav.text3':
    'The manufacture of a piece of jewelry begins with the inspiration of an emotion or idea that is then converted into a design. Expert jewelers convert this design into a unique piece of jewelry using a fabrication process that reflects the tradition of the craft while incorporating innovative production techniques. This piece is made in Mumbai. From the modeling and casting to the finishing, setting and polishing, our craftsmen give shape to this piece with the passion of their profession and their expert dedication.',

  certificates: 'Certificates',
  download: 'Download',

  'digitalPass.header': 'Get your Tracemark ID',
  'digitalPass.step1': 'Authenticate your piece',
  'digitalPass.step2': 'Generate Tracemark ID',

  'digitalPass.uniqueCode': 'Unique alphanumeric code as appears on your piece of jewelry and tag',
  'digitalPass.Authenticate': 'Authenticate',

  'digitalPass.personalDetails': 'Personal Details',
  'digitalPass.email': 'Email',
  'digitalPass.firstName': 'First Name',
  'digitalPass.lastName': 'Last Name',
  'digitalPass.password.text1': 'Set a password',
  'digitalPass.password.text2':
    'Please set a password to register your ownership of this piece of jewelry and secure your Tracemark ID:',
  'digitalPass.password': 'Password',
  'digitalPass.confirmPassword': 'Confirm Password',
  'digitalPass.generateTracemarkIDButton': 'Generate Tracemark ID',

  'digitalPass.notificationHeader': 'Your Tracemark ID is downloading',
  'digitalPass.notificationText':
    'We have also sent it to you using the email address provided. Open the attached Tracemark ID on your smartphone to save it to your digital wallet.',

  'digitalPass.termsAndCondition1': 'I have read and expressly accept the',
  'digitalPass.termsAndCondition2':
    'of "TRACEABLE LUXURY SERVICES, S.L." and the conditions for the processing of my personal data.',

  /* ----------- start Main Consumer Page ------------- */

  'Consumer.sec1.header1': 'DISCOVER THE AUDITED AND CERTIFIED POSITIVE IMPACT OF YOUR JEWELRY',
  'Consumer.sec1.header2': 'OF YOUR JEWELRY',
  'Consumer.sec1.text':
    'This piece of jewelry is a piece of art with its own unique story to tell, verified by an independent third-party auditor. It’s the story traceability tells, proving that your jewelry is authentically a sustainable and ethical creation, from its origin to your hands.',

  'Consumer.ia.text1':
    'All traceability documentation and information for this piece of jewelry has been verified by a reputable external auditor from ',
  'Consumer.ia.text2': ', accredited by the ',

  'downloadDigitalID.text':
    'Register this piece as yours to password-protect this traceability panel and download your Tracemark ID – carry your Tracemark ID with you in your wallet app to share this experience with others.',

  'Consumer.rawMaterials.header': 'MATERIALS',

  'rawMaterials.gold.header1': '100% ETHICAL, RECYCLED AND',
  'rawMaterials.gold.header2': 'TRACEABLE GOLD',
  'rawMaterials.gold.text1':
    'This piece of jewelry is made with 100% ethical, recycled and responsibly sourced gold from suppliers that use CoC gold.',
  'rawMaterials.gold.text2':
    'This ensures that the gold used comes from sources that are verified to meet international environmental best practices and globally recognized social standards.',
  'rawMaterials.gold.notTraceableMaterial': 'Non-Tracemark material:',

  'rawMaterials.diamond.header1': 'TRACEABLE DIAMONDS FROM',
  'rawMaterials.diamond.header2': 'RESPONSIBLE SOURCES',
  'rawMaterials.diamond.text1.1': 'The diamonds in this piece come from the mining company',
  'rawMaterials.diamond.text1.2':
    'The diamonds in this piece come from the known or verified source',
  'rawMaterials.diamond.text1.3':
    ', a certified member of the RJC or a DeBeers Sightholder, which ensures responsible sourcing and compliance with sustainable and ethical practices throughout the supply chain.',
  'rawMaterials.diamond.text2': 'The country of origin of the diamonds is ',
  'rawMaterials.diamond.text3':
    'Each diamond comes with its own Kimberly Process Certificate, verifying its authenticity, provenance, ethical mining and guaranteeing that it is conflict-free.',

  'manufacture.header1': 'ART OF MANUFACTURE',

  'manufacture.text':
    'From modelling and casting to the finishing, setting and polishing, artisans shape emotions into your piece of jewelry, taking care of every detail, filling it with their passion for their trade – polishing it by hand with delicacy and expert dedication.',

  'Consumer.certificates': 'CERTIFICATES',
  'Consumer.download': 'Download',

  /* ----------- end Main Consumer Page ------------- */

  /* ----------- Start Delete TracemarkID Popup ------------- */

  'deleteTracemarkID.link': 'Reset ownership to delete my Tracemark ID',
  'deleteTracemarkID.modal.header': 'Reset Tracemark ID',

  'deleteTracemarkID.step1.password': 'Insert your password',
  'deleteTracemarkID.step1.button': 'Validate',
  'deleteTracemarkID.step1.forgotPasswordLink': 'I forgot my password',

  'deleteTracemarkID.step2.resetText':
    'Please type the word RESET to confirm resetting your Tracemark ID and to allow for the ownership of this piece to be changed or for the piece to be returned.',

  'deleteTracemarkID.step3.success':
    'Thank you. The ownership and Tracemark ID for this piece have been reset.',

  /* ----------- End Delete TracemarkID Popup ------------- */

  'downloadCertificate.text1':
    'To download the Tracemark certificate for this piece, please provide the password used to register its ownership. This is the same password used to download your Tracemark ID.',
  'downloadCertificate.text2':
    'If you have not registered this piece’s ownership, please do so above before downloading this piece’s Tracemark certificate.',

  'downloadCertificate.success':
    'You will shortly receive an email with the Tracemark certificate for this piece attached, delivered to the address used to register its ownership.',

  'downloadCertificate.title': 'Download Certificate',

  /* ----------- Start Tous version 2(v2) changes ------------- */

  'rawMaterials.sec2.v2.text1':
    'The diamonds found in this jewelry piece have been sourced from diamond cutters members from De Beers Sightholder Group, ensuring responsible sourcing and sustainable practices.',
  'rawMaterials.sec2.v2.text2':
    'Every single diamond is verified with its own Kimberley Process Certificate that verifies its authenticity, provenance and ethical extraction.',
  'rawMaterials.sec2.v2.text3':
    'The Kimberley Process Certificate imposes extensive requirements on its members to permit them to certify shipments of raw diamonds as “conflict free” in order to avoid conflict diamonds from entering legitimate trade.',
  /* ----------- End Tous version 2(v2) changes ------------- */

  /* ----------- Start Tous Platinum version 2(v2) changes ------------- */

  'tousPlatinumPanel.rawMaterials.sec1.header1': '100% ETHICAL',
  'tousPlatinumPanel.rawMaterials.sec1.header2': 'PLATINUM',
  'tousPlatinumPanel.rawMaterials.sec1.text1':
    "This piece of jewelry has been crafted with 100% ethical and responsibly sourced platinum, obtained from European refineries accredited by the Responsible Jewellery Council (RJC). These refineries meet the certifications of the Code of Practices (CoP) and Chain of Custody (CoC), ensuring the metal's sustainability.",
  'tousPlatinumPanel.rawMaterials.sec1.text2':
    'The platinum used comes from verified sources that adhere to the highest international environmental and social standards, ensuring a positive impact at every stage of production.',

  'tousPlatinumPanel.rawMaterials.sec2.header1': 'TRACEABLE,',
  'tousPlatinumPanel.rawMaterials.sec2.header2': 'RESPONSIBLY CREATED',
  'tousPlatinumPanel.rawMaterials.sec2.header3': 'LAB-GROWN DIAMONDS',
  'tousPlatinumPanel.rawMaterials.sec2.text1':
    'The laboratory-grown diamonds (LGDs) featured in this jewelry piece have been sourced from growers and diamond cutters who are verified members of the SMETA (Sedex Members Ethical Trade Audit) framework. This affiliation guarantees that all operations, including working conditions and environmental practices, adhere to the highest standards of ethical and sustainable business conduct throughout the supply chain.',
  'tousPlatinumPanel.rawMaterials.sec2.text2':
    'By partnering with SMETA-compliant entities, we ensure that our entire supply chain aligns with best practices in sustainability and ethical performance.',
  'tousPlatinumPanel.rawMaterials.sec2.text3':
    'Additionally, our business partners are fully compliant with Environmental, Social, and Governance (ESG) criteria, underscoring our commitment to responsible and sustainable sourcing.',
  /* ----------- End Tous Platinum version 2(v2) changes ------------- */

  /* ----------- Start Dynamic Panel Digital pass ------------- */
  'dynamicPanelsDigitalPass.header': 'Get your Tracemark Passport',
  'dynamicPanelsDigitalPass.generateTracemarkIDButton': 'Get your Tracemark Passport',

  'dynamicPanelsDigitalPass.uniqueCode':
    'Enter the alphanumeric code displayed on your Tracemark Tag',

  'dynamicPanelsDigitalPass.email': 'Email',
  'dynamicPanelsDigitalPass.email2': 'Email',
  'dynamicPanelsDigitalPass.firstName': 'Name',
  'dynamicPanelsDigitalPass.lastName': 'Last Name',
  'dynamicPanelsDigitalPass.password': 'Password',

  'dynamicPanelsDigitalPass.notificationHeader': 'Your Tracemark ID is downloading',
  'dynamicPanelsDigitalPass.notificationText':
    'We have also sent it to you using the email address provided. Open the attached Tracemark ID on your smartphone to save it to your digital wallet.',

  'dynamicPanelsDigitalPass.termsAndCondition1': 'I have read and expressly accept the',
  'dynamicPanelsDigitalPass.termsAndCondition2': ' privacy policy ',
  'dynamicPanelsDigitalPass.termsAndCondition3':
    'of "TRACEABLE LUXURY SERVICES, S.L." and the terms of the processing of my personal data',

  'dynamicPanelsDigitalPass.resetOwnership': 'Reset the ownership of your Tracemark Passport',
  'dynamicPanelsDigitalPass.password.text':
    'Please enter your Password to recover your Tracemark Passport',
  'dynamicPanelsDigitalPass.forgotPassword': 'Forgot Password?',

  'dynamicPanelsDigitalPass.step1': 'Authenticate your piece',
  'dynamicPanelsDigitalPass.step2': 'Generate Tracemark Passport',
  'dynamicPanelsDigitalPass.Authenticate': 'Authenticate',
  'dynamicPanelsDigitalPass.personalDetails': 'Personal Details',
  'dynamicPanelsDigitalPass.password.text1': 'Set a password',
  'dynamicPanelsDigitalPass.password.text2':
    'Please set a password to register your ownership of this piece of jewelry and secure your Tracemark Passport:',
  'dynamicPanelsDigitalPass.confirmPassword': 'Confirm Password',

  'dynamicPanelsDigitalPass.required.uniqueCode': 'Please enter unique code',
  'dynamicPanelsDigitalPass.required.name': 'Please enter first name',
  'dynamicPanelsDigitalPass.required.lastName': 'Please enter last name',
  'dynamicPanelsDigitalPass.required.email': 'Please enter email',
  'dynamicPanelsDigitalPass.required.validEmail': 'Please enter valid email',
  'dynamicPanelsDigitalPass.required.terms': 'Please accept the terms and conditions',
  'dynamicPanelsDigitalPass.required.password': 'Please enter password',
  'dynamicPanelsDigitalPass.required.confirmPassword': 'Please enter confirm password',
  'dynamicPanelsDigitalPass.required.matchPassword':
    'Your new password and confirm password do not match',
  /* ----------- End  Dynamic Panel Digital pass ------------- */
}

export default {
  locale: 'en-US',
  antdData,
  localeData,
  messages,
}
